import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../../../../modules/infra/i18n';
import ShopifySettingsForm from '../ShopifySettingsForm';
import DisconnectShopify from '../DisconnectShopifyModal';
import Spinner from '../../../../../common/Spinner';
import shopifyIcon from '../../../../../../../images/shopifyIcon.png';

const ShopifySettingsPage = ({ initializedIsOn }) => (
  <div className="shopify-settings-page" data-automation-id="shopify-settings-page">
    <div className="shopify-settings-page__body">
      <h1>Shopify</h1>
      <p>{t('settings:integrations.shopify.sync_description')}</p>
      <img alt="shopify-logo" className="shopify-logo" src={shopifyIcon} role="presentation" />
      <ShopifySettingsForm display-if={initializedIsOn} />
      <Spinner display-if={!initializedIsOn} />
      <div className="shopify-settings-page__body__actions">
        <DisconnectShopify connectedProductsCount={10} />
        <button type="submit" className="c-btn c-btn--medium" form="shopify-settings-form">
          <span className="c-btn__text">{t('common:buttons.save')}</span>
        </button>
      </div>
    </div>
  </div>
);

ShopifySettingsPage.propTypes = {
  initializedIsOn: PropTypes.bool.isRequired,
};

export default ShopifySettingsPage;
